import cx from 'classnames'
import { HeaderProps } from './Types'
import Styles from './TableHeaders.module.scss'
import { DefaultType } from 'api/clients/PropertyClient'
import { Text } from 'blaze-ui/Text/Text'
import { ArrowUpSm } from 'blaze-ui/icons'
import { SortingDirection } from 'api/clients/FilesViewsClient'

export const Header = ({ property, onClick, sortingDirection }: HeaderProps) => {
  const isTitle = property.default_type === DefaultType.Name
  const color = Boolean(sortingDirection) ? 'var(--dark-60)' : 'var(--dark-40)'

  return (
    <div className={cx(Styles.th, { [Styles.name]: isTitle })} onClick={onClick}>
      <Text variant="placeholder" color={color}>
        {property.name}
      </Text>
      {sortingDirection && (
        <div className={cx(Styles.sorting, { [Styles.descending]: sortingDirection === SortingDirection.Descending })}>
          <ArrowUpSm color={color} />
        </div>
      )}
    </div>
  )
}
